import { CoreFollowedIdMapName } from './name';
import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { defaultFollowedIdMapState } from './state';

export const removeCoreFollowedIdMapSlice = createRemoveSyncSlice({
	name: CoreFollowedIdMapName,
	state: defaultFollowedIdMapState,
	transform: (action: Array<number>, state = {}) => {
		if (!action.length) {
			return state;
		}

		for (const entry of action) {
			delete state[ entry ];
		}

		return state;
	}
});
